import { PermissionKey } from "~/types/Permissions";

export interface OptionDownloadConfig {
  value: "download_indicators" | "download_dealers";
  permissions: PermissionKey[];
}

export const SELECT_TYPE_OPTIONS: OptionDownloadConfig[] = [
  { value: "download_indicators", permissions: ["indicator.values.download"] },
  { value: "download_dealers", permissions: ["dealergraph.download"] },
];
export const SELECT_FILE_TYPE_OPTIONS = ["full", "upload"];
